import {
	GET_CURRENT_USER_INFOS,
	AUTH_LOGOUT,
	SET_UPSELL_TOKEN,
	SET_CURRENT_CLIENT,
	GET_UPSELL_TOKEN_FROM_MICROSOFT,
} from "./../types";
import _ from "lodash";

import { updateIntl } from "react-intl-redux";
import {
	removeSurveyProgress,
} from "./surveyActions";
import { STATS_RESET } from "../../modules/stats/actions/stats";



export const authGetUpsellTokenFromMicrosoft = microsoftIdToken => ({
	type: GET_UPSELL_TOKEN_FROM_MICROSOFT,
	microsoftIdToken
});

export const authGetCurrentUserInfos = () => {
	return {
		type: GET_CURRENT_USER_INFOS,
	};
};

export const authLogout = () => ({
	type: AUTH_LOGOUT,
});

export const setAuthToken = token => ({
	type: SET_UPSELL_TOKEN,
	token,
});

export function setCurrentClient(clientInfos) {
	return (dispatch, getState) => {
		const state = getState();

		//change client data
		dispatch({ type: SET_CURRENT_CLIENT, clientInfos });

		//reset saved survey from local storage (if current client selected)
		const currentClient = state.currentClient || {};
		if (currentClient.id) {
			dispatch(removeSurveyProgress());
		}

		//stats reset
		dispatch({ type: STATS_RESET });
	};
}

export const changeLanguage = language => updateIntl({ locale: language });
export const __setCurrentClient = clientInfos => ({
	type: SET_CURRENT_CLIENT,
	clientInfos,
});



// WEBPACK FOOTER //
// src/redux/actions/authActions.js